/** @format */

import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Checkout } from '@cart-checkout/data-access/interfaces';
import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Environment } from '@shared/data-access/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShippingDao {
  private readonly environment = inject(Environment);
  private readonly http = inject(HttpClient);
  private readonly DEFAULT_HTTP_HEADERS = new HttpHeaders({
    Accept: MediaType.APPLICATION_JSON,
    Pragma: 'no-cache',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
    'Content-Type': MediaType.APPLICATION_JSON,
    'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.short}`,
  });

  /**
   * @description Get rewards for an athlete.
   */
  public updateShippingOption$ = (checkoutKey: string, shipMode: any, groupNumber: number) => {
    const url = `${this.environment.api.checkout.basePath}/${checkoutKey}/shipping/selected/groups/${groupNumber}/mode`;

    const httpOptions = {
      headers: this.DEFAULT_HTTP_HEADERS,
      withCredentials: true,
    };

    return this.http.put<Checkout>(url, shipMode, httpOptions);
  };

  /**
   * @returns a checkout object
   *
   * @description
   * Update shipping method by checkoutKey, shipMode and groupNumber
   *
   * @param orderId
   * @param shipMode
   * @param groupNumber
   */
  public updateModernShippingOption$(
    orderId: string,
    shipMode: any,
    groupNumber: number,
  ): Observable<Checkout> {
    const url = `${this.environment.api.checkout.basePath}/${orderId}/shipping/selected/groups/${groupNumber}/mode`;

    const httpOptions = {
      headers: this.DEFAULT_HTTP_HEADERS,
      withCredentials: true,
    };

    // set modern checkout http header to identify requests that we want to run translation on
    httpOptions.headers = this.setDefaultModernHttpHeaders(httpOptions);

    const shipModeBody = {
      description: shipMode.description,
      shipMethod: shipMode.ship_method,
      unitPrice: shipMode.unit_price,
    };

    return this.http.put<Checkout>(url, shipModeBody, httpOptions);
  }

  private setDefaultModernHttpHeaders(request: any): HttpHeaders {
    let httpHeaders = request.headers;
    httpHeaders = httpHeaders.set(CustomHttpHeaders.X_CHK_MOD, 'true');
    httpHeaders = httpHeaders.set(CustomHttpHeaders.CHK, '2');
    return httpHeaders;
  }
}
